import client from "../libs/HttpClient";

class AccountServices {
  static updateProfile(request) {
    return client.post(`/profile`, request, {});
  }
  static viewProfile(params) {
    return client.get(`/get-profile`, { params });
  }
}
export { AccountServices };
